<template>
  <div class="details">
    <div class="details-box">
      <div class="details-title">{{ course.title }}</div>
      <div class="details-cover">
        <div class="cover-img">
          <img :src="course.img_url" alt />
        </div>
        <div class="cover-msg">
          <div class="title">{{ course.name }}</div>
          <div :class="showprice == '免费' ? 'free common' : 'price common'">
            价格：
            <span v-if="priceshow == true">¥{{ course.real_price / 100 }}</span>
          </div>
          <div class="scope common">简介：{{ course.brief }}</div>
          <!-- <div class="deadline common">学习有效期：永久有效</div> -->
          <div class="views common">{{ course.viewer_num }}人看过</div>
          <div class="operation">
            <div class="buy" @click="buyVideo">
              {{
                course.on_public == 1
                  ? showprice
                  : course.is_auth == 1
                  ? "已购买"
                  : showprice
              }}
            </div>
            <div
              class="collect"
              v-for="(item, index) in collect"
              :key="index"
              v-show="index == collectChecked"
              @click="changCollect"
            >
              <img :src="item.img_url" alt />
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="details-content">
        <div class="details-menu">
          <div class="navbar-right">
            <ul class="link-list">
              <li
                v-for="item in linkList"
                :key="item.id"
                :class="menu == item.id ? 'active' : ''"
                @click="changeList(item.id)"
              >
                {{ item.name }}
              </li>
            </ul>
            <img
              src="@img/comment.png"
              v-show="menu == 3"
              @click="showReplyModal"
              alt
            />
          </div>
          <div class="list-show" v-show="menu == 1">
            <div class="mix" v-for="(zz, index) in arr" :key="index">
              <div
                class="item parent underborder"
                v-for="(item, index) in zz"
                :key="index"
                :style="[
                  {
                    paddingLeft: item.rank * 16 + 16 + 'px',
                  },
                ]"
                v-bind:class="{
                  border: treeParams.border === true,
                  unshow: !item.show,
                  last: item.lastRank,
                  back: item.rank > 0 && !item.lastRank,
                  toback: item.rank > 0 && item.lastRank,
                  showchild: item.showChild,
                }"
                @click.stop="treeItemTap(item, index)"
              >
                <!-- <img
                  class="mix-tree-icon lefticon"
                  :src="item.lastRank ? treeParams.lastIcon :treeParams. parentIcon"
                /> -->
                <img
                  class="chapsec"
                  v-if="item.category == 9"
                  :src="chapSec.chapter"
                  alt=""
                />
                <img
                  class="chapsec"
                  v-if="item.category == 10"
                  :src="chapSec.setion"
                  alt=""
                />
                <img
                  class="chapsecs"
                  v-if="item.category == 11"
                  :src="chapSec.zhuan"
                  alt=""
                />
                <img
                  class="chapsecs"
                  v-if="item.category == 12"
                  :src="chapSec.zhuan"
                  alt=""
                />
                <img
                  :src="chapSec.videos"
                  v-if="item.type == 0"
                  class="chapsecss"
                  alt=""
                />
                <div class="contents">
                  <div class="name">{{ item.title }}</div>
                  <div
                    class="btn color2"
                    v-if="item.lastRank"
                    @click="showVideos(item)"
                  >
                    {{ item.type == 1 ? "立即观看" : "播放器观看" }}
                  </div>
                </div>
                <img
                  class="mix-tree-icon"
                  v-if="!item.lastRank"
                  :src="
                    item.showChild
                      ? treeParams.currentIcon
                      : treeParams.defaultIcon
                  "
                />
              </div>
            </div>
          </div>
          <div class="list-details" v-show="menu == 2">
            <div v-html="course.details" class="deta"></div>
          </div>
          <div class="list-question" v-show="menu == 3">
            <div
              class="comment-list"
              v-for="(item, index) in question"
              :key="index"
            >
              <CourseQuesAns :item="item" />
            </div>
          </div>
        </div>
        <div class="details-introduce">
          <div class="introduce-title">名师</div>
          <div class="introduce-cover">
            <div class="img">
              <img :src="teacher.img_url" alt />
            </div>
            <div class="introduce-brief">
              <span>{{ teacher.name }}</span>
              <span class="brief">{{ teacher.scope }}</span>
            </div>
          </div>
          <div class="introduce-content">
            <p>{{ teacher.brief }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="video-player" v-if="showVideo">
      <div class="title">
        {{ video_name }}
        <img src="@img/close.png" @click="changeShow" alt />
      </div>
      <VideoPlayer :source="video_url" :freeTimes="freeTimes" />
    </div>
    <div class="shades" v-show="showVideo"></div>
    <div class="shades" v-show="showShades"></div>
    <div class="shades" v-show="showBuyshades"></div>
    <div class="shades" v-show="showApp"></div>
    <div class="reply" v-show="showShades">
      <p>{{ replyTitle }}：</p>
      <a-textarea
        class="reply-box"
        maxlength="101"
        @input="changeInput()"
        onchange="this.value=this.value.substring(0, 200)"
        onkeydown="this.value=this.value.substring(0, 200)"
        onkeyup="this.value=this.value.substring(0, 200)"
        v-model="message"
        placeholder="请输入评论"
      />
      <a-button class="reply-btn" type="primary" block @click="commitReply"
        >提交</a-button
      >
      <a-button class="reply-btn" block @click="cancel">取消</a-button>
    </div>
    <div class="showBuy" v-if="showBuy">
      <div class="head">
        <p>积分抵扣</p>
        <img src="@img/close.png" @click="cancelOrder" alt />
      </div>
      <div class="main">
        <div class="price-num">
          需支付：
          <span>{{ course.price }}元</span>
        </div>
        <p class="point-ruler">使用积分抵扣 (当前可用积分:{{ my_points }})</p>
        <div class="ponit-select">
          <a-radio-group v-model="value">
            <a-radio :style="radioStyle" :value="0">不使用积分抵扣</a-radio>
            <a-radio :style="radioStyle" :value="1" :disabled="disabled"
              >每{{ cost_b_p_ratio }}积分可抵扣1元（最多抵扣{{
                can_offset_price
              }}元）</a-radio
            >
          </a-radio-group>
        </div>
        <div class="commit-order">
          <a-button class="commite-sure" type="primary" @click="toPay(value)"
            >确认</a-button
          >
          <a-button @click="cancelOrder">取消</a-button>
        </div>
      </div>
    </div>
    <div class="showBuy" v-show="order">
      <div class="heads">
        <img
          src="@img/close.png"
          @click="
            showBuyshades = false;
            order = false;
          "
          alt
        />
      </div>

      <canvas ref="order"></canvas>
      <p>通过微信扫一扫</p>
      <p>扫描二维码进行支付</p>
      <a-button class="complete-btn" @click="complete(order_no)" type="primary"
        >支付完成？点我刷新</a-button
      >
    </div>
    <div class="showApp" v-show="showApp">
      <span class="quxiao" @click="showfals">X</span>
      <div class="second">
        <p>为了提升观看体验，请下载EVPlayer2登录账号观看。</p>
        <a class="download-buttom" target="_new" href="https://www.ieway.cn/evplayer2.html">立即下载</a>
        <p>账号：{{en2Info && en2Info.en2_account}} <a
          v-clipboard:copy="en2Info.en2_account"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          复制
        </a></p>
        <p>密码：{{en2Info && en2Info.en2_pwd}} <a
          v-clipboard:copy="en2Info.en2_pwd"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          复制
        </a></p>
      </div>
    </div>
    <a-alert
      type="error"
      class="toast"
      message="请登录"
      banner
      v-if="showWarning"
    />
    <a-alert
      class="toast"
      message="播放错误"
      description="请先购买后再播放"
      type="error"
      showIcon
      v-if="showToast"
    />
    <a-alert
      :message="errmsg"
      v-if="errshow"
      class="errshow"
      type="error"
      showIcon
    />
    <a-alert
      :message="sucmsg"
      v-if="sucshow"
      type="success"
      class="errshow"
      showIcon
    />
  </div>
</template>
<script>
const columns = [
  {
    title: "title",
    dataIndex: "title",
    key: "title",
    width: "100%",
  },
];
import CourseMenu from "./components/CourseMenu.vue";
import CourseQuesAns from "./components/CourseQuesAns.vue";
import VideoPlayer from "./components/VideoPlayer";
// import QRCode from 'qrcodejs2'
import { mapState, mapMutations } from "vuex";
import QRCode from "qrcode";
import {
  getCookie,
  group_sign,
  htmlDecode,
  GetClear,
  sortKey,
} from "../../utils/tool";
export default {
  name: "course_details",
  components: {
    CourseMenu,
    CourseQuesAns,
    VideoPlayer,
  },
  data() {
    return {
      freeTimes: 0,//试看时间
      en2Info:{},
      messages: "http:asbcjhasbgcuyahscyugsahbciuahsiuch",
      showApp: false,
      columns,
      dataOfChapter: [],
      value: 0,
      disabled: false,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
        marginTop: "10px",
      },
      showWarning: false,
      showBuyshades: false,
      order_no: "",
      linkList: [
        { name: "课程目录", id: 1 },
        { name: "课程详情", id: 2 },
        { name: "学员评论", id: 3 },
      ],
      course_id: null,
      menu: 1,
      chapterList: [],
      course: [],
      teacher: [],
      question: [],
      can_offset_price: 0,
      cost_b_p_ratio: 0,
      my_points: 0,
      open_bonus_points: 0,
      order: false,
      collect: [
        { text: "收藏", img_url: require("@img/star.png") },
        { text: "已收藏", img_url: require("@img/star2.png") },
      ],
      showShades: false,
      message: "",
      course_id: "",
      course_type: "",
      root_id: 0,
      at_id: 0,
      replyTitle: "课程评论",
      collectChecked: "",
      showBuy: false,
      showprice: "",
      student_id: Number(getCookie("studentId")),
      userName: getCookie("userAcount"),
      showToast: false,
      errshow: false,
      errmsg: "",
      autoExpandParent: true,
      treeList: [],
      arr: [],
      treeParams: {
        defaultIcon: require("@img/fold@2x.png"),
        currentIcon: require("@img/unfold@2x.png"),
        lastIcon: require("@img/video.png"),
        parentIcon: require("@img/chapter@2x.png"),
        border: false,
      },
      chapSec: {
        chapter: require("@img/chapter@2x.png"),
        setion: require("@img/sections@2x.png"),
        zhuan: require("@img/zhuanti.png"),
        videos: require("@img/videos.png"),
      },
    };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  computed: {
    ...mapState([
      "showVideo",
      "video_name",
      "video_url",
      "isLogin",
      "priceshow",
    ]),
  },
  created() {},
  methods: {
    changeInput() {
      if (this.message.length > 100) {
        alert("输入字数不能超过100");
      }
    },
    goBack() {
      // console.log("点击了浏览器的返回按钮");
      sessionStorage.clear();
      window.history.back();
      history.pushState(null, null, document.URL);
      this.$store.commit("setState", {
        key: "showVideo",
        value: false,
      });
    },
    showfals() {
      this.showApp = false;
    },
    onCopy(e) {
      this.$message.success("复制成功 ");
    },
    onError(e) {
      calert("无法复制文本！");
    },
    changeList(id) {
      this.menu = id;
    },
    onExpand(expandedKeys) {
      this.autoExpandParent = false;
    },
    // 跳转老师详情
    toDetails(item) {
      this.$router.push({
        path: "/page/teacher_details",
        query: { id: item.id },
      });
    },
    //播放视频
    showVideos(item) {
      let that = this;
      let course_id = Number(this.$route.query.course_id);
      if (that.isLogin) {
        if (item.type == 1) {
            var param = group_sign({
              course_id: course_id,
              student_id: that.student_id,
              video_id: item.id,
            });
            this.$axios
              .post(this.$Api.apiCheckAuthorization, param)
              .then((res) => {
                if (
                  typeof res.data.errcode == "undefined" ||
                  res.data.errcode == 0
                ) {
                  that.$store.commit("setState", {
                    key: "video_url",
                    value: res.data.result.play_url,
                  });
                  that.$store.commit("setState", {
                    key: "video_name",
                    value: item.title,
                  });
                  that.$store.commit("setState", {
                    key: "showVideo",
                    value: true,
                  });
                  that.freeTimes = res.data.result.free_times
                } else {
                  this.$message.error(res.data.errmsg);
                }
              });
        } else {
          if (that.course.on_public == 1) {
              this.$message.error("请下载加密播放器观看！")
              return
          } 
          if (that.course.is_auth == 0) {
            this.$message.error("无播放权限！")
            return
          }
          var param = group_sign({
              student_id: that.student_id,
          });
           this.$axios
              .post(this.$Api.apiClientGetStudentEn2Info, param)
              .then((res) => {
                that.en2Info = res.data.result
                that.showApp = true;
              })
        }
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    // 获取章节目录
    getCourseChapter(course_id) {
      let that = this;
      var param = group_sign({ course_id: Number(course_id) });
      this.$axios.post(this.$Api.apiGetCourseListById, param).then((res) => {
        let obj = res.data.result.courseList;
        that.chapterList = obj.children;
        if (!obj.children && !obj.files) {
          that.dataOfChapter = [];
        } else {
          that.dataOfChapter.push(obj);
        }
        this.renderTreeList(that.dataOfChapter);
        this.sliceTreeList();
      });
    },
    //扁平化树结构
    renderTreeList(list, rank = 0, parentId = []) {
      this.arr = [];
      list.forEach((item) => {
        this.treeList.push({
          id: item.id,
          parentId,
          rank, //层级
          title: item.title || item.name,
          type: item.type,
          showChild: false, //子级是否显示
          show: rank === 1, // 自身是否显示
          category: item.category,
          upload_key: item.upload_key,
          play_url: item.src_url,
          prime_price: item.prime_price,
        });
        if (
          (Array.isArray(item.children) && item.children.length > 0) ||
          (Array.isArray(item.files) && item.files.length > 0)
        ) {
          if (Array.isArray(item.children) && item.children.length > 0) {
            let parents = [...parentId];
            parents.push(item.course_id || item.id);
            item.children = sortKey(item.children, "order_num");
            this.renderTreeList(item.children, rank + 1, parents);
          }
          if (Array.isArray(item.files) && item.files.length > 0) {
            let parents = [...parentId];
            parents.push(item.course_id || item.id);
            item.files = sortKey(item.files, "order_num");
            this.renderTreeList(item.files, rank + 1, parents);
          }
        } else {
          if (!item.category) {
            this.treeList[this.treeList.length - 1].lastRank = true;
          }
        }
        if (item.children == "" && item.files == "") {
          this.treeList[this.treeList.length - 1].lastRank = false;
        }
      });
    },
    //分割树结构
    sliceTreeList() {
      //记录每个最上级父节点的位置
      let num = [];
      this.treeList.forEach((item, index) => {
        if (item.rank == 0) {
          num.push(index);
        }
      });
      //分割树结构
      if (num.length == 1) {
        this.arr.push(this.treeList);
      } else if (num.length > 1) {
        for (let index = 0; index < num.length; index++) {
          if (index < num.length - 1) {
            this.arr.push(this.treeList.slice(num[index], num[index + 1]));
          } else if (index == num.length - 1) {
            this.arr.push(this.treeList.slice(num[index]));
          }
        }
      }
      this.treeParams = Object.assign(this.treeParams);
    },
    // 点击
    treeItemTap(item) {
      let list = this.treeList;
      let id = item.id;
      item.showChild = !item.showChild;
      list.forEach((childItem) => {
        if (item.showChild === false) {
          //隐藏所有子级
          if (!childItem.parentId.includes(id)) {
            return;
          }
          if (childItem.lastRank !== true) {
            childItem.showChild = false;
          }
          childItem.show = false;
        } else {
          if (childItem.parentId[childItem.parentId.length - 1] === id) {
            childItem.show = true;
          }
        }
      });
    },
    // 获取课程详情
    getCourseDes(course_id, course_type) {
      let that = this;
      var param = group_sign({
        course_id: course_id,
        student_id: that.student_id,
      });
      this.$axios.post(this.$Api.queryCourseDetailsById, param).then((res) => {
        if (res.data.errcode == 0) {
          that.course = res.data.result;
          this.$store.commit("setState", {
            key: "course",
            value: res.data.result,
          });
          that.teacher = res.data.result.teacher;
          if (that.course.on_public == 1) {
            that.showprice = "免费";
          } else {
            that.showprice = "￥" + that.course.real_price / 100;
          }
          if (that.course.details != null) {
            let htmls = htmlDecode(that.course.details);
            that.course.details = this.convert(htmls);
          }
          if (that.course.brief != null) {
            that.course.brief = GetClear(that.course.brief);
          }
          that.collectChecked = that.course.is_collect;
        } else {
          that.$message.error(res.data.errmsg);
        }
      });
    },
    // 正则匹配教验  搞死哥了
    convert(htmlstr) {
      let htmlText = htmlstr;
      let str = htmlText.replace(/<(img).*?(\/>|<\/img>)/g, function (a) {
        if (a.indexOf("style") < 0) {
          return a.replace(
            /<\s*img/,
            '<img style="max-width:100%;height:auto"'
          );
        } else {
          return a.replace(/style=("|')/, "style=$1max-width:100%;height:auto");
        }
      });
      return str;
    },
    imgTagAddStyle(htmlstr) {
      // 正则匹配所有img标签
      // var regex0 = new RegExp("(i?)(\<img)([^\>]+\>)","gmi");
      // 正则匹配不含style="" 或 style='' 的img标签
      // eslint-disable-next-line no-useless-escape
      var regex1 = new RegExp(
        "(i?)(<img)(?!(.*?style=['\"](.*)['\"])[^>]+>)",
        "gmi"
      );
      // 给不含style="" 或 style='' 的img标签加上style=""
      htmlstr = htmlstr.replace(regex1, '$2 style=""$3');
      // console.log('增加style=""后的html字符串：' + htmlstr)
      // 正则匹配含有style的img标签
      // eslint-disable-next-line no-useless-escape
      var regex2 = new RegExp("(i?)(<img.*?style=['\"])([^>]+>)", "gmi");
      // 在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
      htmlstr = htmlstr.replace(regex2, "$2max-width:100%;height:auto;$3");
      // console.log('在img标签的style里面增加样式后的html字符串：' + htmlstr)
      return htmlstr;
    },

    getCourseQuesAns(course_id) {
      let that = this;
      var param = group_sign({ course_id: course_id });
      this.$axios
        .post(this.$Api.apiGetCourseCommentList, param)
        .then((res) => {
          that.question = res.data.result.list;
        })
        .catch((error) => {
          console.log(error, ">>>>>>>>>");
        });
    },
    changeShow() {
      this.$store.commit("setState", { key: "showVideo", value: false });
    },
    // 课程评论
    commitReply() {
      let course_id = this.course_id,
        message = this.message,
        that = this;
      var param = group_sign({
        course_id: course_id,
        content: message,
        student_id: that.student_id,
        user_name: that.userName,
      });
      this.$axios
        .post(this.$Api.apiGetCourseComentReply, param)
        .then((res) => {
          if (res.data.errcode == 0) {
            that.message = "";
            that.replyTitle = "评论";
            that.root_id = 0;
            that.at_id = 0;
            that.showShades = false;
            this.$message.success("评论成功！");
            // that.getCourseQuesAns(course_id);
          } else if (res.data.errcode == 403) {
            that.$message.error(res.data.errmsg);
            let timeErrors = setTimeout(() => {
              this.$root.Bus.$emit("showLogin");
              clearTimeout(timeErrors);
            }, 2000);
          }
        })
        .catch((error) => {});
    },
    qrcode(code) {
      QRCode.toCanvas(
        this.$refs.order,
        code,
        { errorCorrectionLevel: "H" },
        (error) => {
          if (error) {
            // console.log(111);
          } else {
            console.log("suceess");
          }
        }
      );
    },
    cancel() {
      this.message = "";
      this.showShades = false;
    },
    cancelOrder() {
      this.showBuy = false;
      this.showBuyshades = false;
    },
    // show(root_id, at_id, replyTitle) {
    //   if (replyTitle) {
    //     this.replyTitle = "回复" + replyTitle;
    //   }
    //   if (root_id) {
    //     this.root_id = root_id;
    //   }
    //   if (at_id) {
    //     this.at_id = at_id;
    //   }
    //   if (this.isLogin) {
    //     this.showShades = true;
    //   } else {
    //     this.$root.Bus.$emit("showLogin")
    //   }
    // },
    showReplyModal() {
      if (this.isLogin) {
        this.showShades = true;
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    // 课程收藏
    changCollect() {
      let course_id = this.$route.query.course_id;
      if (this.isLogin) {
        if (this.collectChecked == 0) {
          var param = group_sign({
            account_id: this.account_id,
            student_id: this.student_id,
            video_course_id: course_id,
            collect_state: 1,
          });
          this.$axios.post(this.$Api.apiGetCourseCollect, param).then((res) => {
            if (res.data.errcode == 0) {
              this.getCourseDes(course_id);
            } else if (res.data.errcode == 1 || res.data.errcode == 2) {
              this.errmsg = res.data.errmsg;
              this.errshow = true;
              let timeErrzzss = setTimeout(() => {
                this.errshow = false;
                this.errmsg = "";
                clearTimeout(timeErrzzss);
              }, 2000);
            } else {
              this.errmsg = res.data.errmsg;
              this.errshow = true;
              let timeErrzz = setTimeout(() => {
                this.errshow = false;
                this.errmsg = "";
                clearTimeout(timeErrzz);
              }, 2000);
              let timeErrors = setTimeout(() => {
                this.$root.Bus.$emit("showLogin");
                clearTimeout(timeErrors);
              }, 2000);
            }
          });
        } else {
          var param = group_sign({
            account_id: this.account_id,
            student_id: this.student_id,
            video_course_id: course_id,
            collect_state: 0,
          });
          this.$axios.post(this.$Api.apiGetCourseCollect, param).then((res) => {
            if (res.data.errcode == 0) {
              this.getCourseDes(course_id);
            } else if (res.data.errcode == 1 || res.data.errcode == 2) {
              this.errmsg = res.data.errmsg;
              this.errshow = true;
              let timeErrzzss = setTimeout(() => {
                this.errshow = false;
                this.errmsg = "";
                clearTimeout(timeErrzzss);
              }, 2000);
            } else {
              this.errmsg = res.data.errmsg;
              this.errshow = true;
              let timeErrzz = setTimeout(() => {
                this.errshow = false;
                this.errmsg = "";
                clearTimeout(timeErrzz);
              }, 2000);
              let timeErrors = setTimeout(() => {
                this.$root.Bus.$emit("showLogin");
                clearTimeout(timeErrors);
              }, 2000);
            }
          });
        }
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    // 购买视频
    buyVideo() {
      if (getCookie("token")) {
        if (
          this.course.real_price > 0 &&
          this.course.is_auth == 0 &&
          this.course.on_public == 0
        ) {
          alert("请联系商家！")
          // this.toPay();
        }
      } else {
        this.$root.Bus.$emit("showLogin");
      }
    },
    toPay() {
      let that = this;
      let course_id = that.course_id;
      let student_id = that.student_id;
      that.order = true;
      that.showBuyshades = true;
      var param = group_sign({
        course_id: course_id,
        student_id: student_id,
        is_in_wechat: 3,
      });
      this.$axios.post(this.$Api.apiToBuyCourse, param).then((res) => {
        that.qrcode(res.data.result);
      });
    },
    // complete(order_no) {
    //   let that = this;
    //   return new Promise((resolve, reject) => {
    //     apiCheckCourseOrder({ order_no: order_no })
    //       .then(res => {
    //         if (res.result == 1) {
    //           alert("支付成功");
    //           that.order = false;
    //           that.showBuyshades = false;
    //           that.getCourseDes(that.course_id, that.course_type);
    //         } else {
    //           alert("支付失败");
    //         }
    //       })
    //       .catch(error => {});
    //   });
    // }
    complete() {
      this.showBuyshades = false;
      this.order = false;
      this.getCourseDes(this.course_id);
    },
  },
  beforeMount() {
    let course_id = Number(this.$route.query.course_id);
    let course_type = this.$route.query.course_type;
    this.course_id = course_id;
    this.course_type = course_type;
    this.getCourseChapter(course_id, course_type);
    this.getCourseDes(course_id, course_type);
    this.getCourseQuesAns(course_id);
  },
};
</script>
<style lang="less" scoped>
@import url("../../assets/less/courseDetails.less");
</style>
